<template>
  <div class="recommendations pb-5" :class="{'no-margin': remainingServiceTypes}">
    <progress-bar v-if="hasRemainingServiceTypes" />
    <div class="v-expansion-panel">
      <template v-if="remainingServiceTypes && remainingServiceTypes.length">
        <service-type
          v-for="serviceType in remainingServiceTypes"
          :service-type="serviceType"
          :key="serviceType.id" />
      </template>
      <add-another />
    </div>
    <confirm-nonlisting-modal />
  </div>
</template>

<script>
  // Note (mikew): Expansion Panel styles used, but component not used since it doesn't support custom animations
  import { mapState, mapGetters } from 'vuex'
  import ProgressBar from './ProgressBar'
  import ServiceType from './ServiceType'
  import AddAnother from './AddAnother'
  import ConfirmNonlistingModal from './ConfirmNonlisting'

  export default {
    computed: {
      ...mapState('layout', ['expanded']),
      ...mapState('recommendations', ['remainingServiceTypes']),
      ...mapGetters('user', ['isLoggedIn']),
      hasRemainingServiceTypes () {
        return this.remainingServiceTypes && this.remainingServiceTypes.length
      }
    },
    methods: {
      getRecommendations () {
        this.$store.dispatch('recommendations/getRemaining')
        if (this.isLoggedIn) {
          this.$store.dispatch('recommendations/getProgress')
        }
      }
    },
    components: {
      ProgressBar,
      ServiceType,
      AddAnother,
      ConfirmNonlistingModal
    },
    watch: {
      isLoggedIn () {
        this.getRecommendations()
      }
    },
    mounted () {
      this.getRecommendations()
    }
  }
</script>



// WEBPACK FOOTER //
// frontend/src/components/recommendations/Index.vue